import React, { useEffect, useRef, useState } from "react";
import {
  Grid,
  Typography,
  Switch,
  Button,
  TextField,
  Dialog,
  Tabs,
  Tab,
  DialogContent,
  Backdrop,
  makeStyles,
  IconButton,
  Slide,
  Box,
  DialogActions,
  Avatar,
  Drawer,
  FormControl,
  MenuItem,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
import Permissions from "./permissions";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { fetchUserfromDepartment } from "../../../../../containers/actions/userActions";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import {
  deleteCollaboratorRole,
  updateCollaboratorRoleChanges,
} from "../../../containers/actions/common/rolesAndAccessActions";
import { useDispatch, useSelector } from "react-redux";
import { ChevronRight } from "@material-ui/icons";
import usePrevious from "../../helpers/previousProps";
import {
  DELETE_COLLABORATOR_ROLE,
  UPDATE_COLLABORATOR_ROLE_CHANGES,
} from "../../../containers/actions/types";
import BackDropLoading from "../models/BackDrop";
import EditTeamMembers from "./EditTeamMembers";
import { FETCH_USERFROM_DEPT_LOADING } from "../../../../../containers/actions/types";
import { fetchTeamAssociates } from "../../../containers/actions/common/teamMemberAction";
import { FETCH_TEAM_ASSOCIATES_LOADING } from "../../../containers/actions/types";
import { convertToLocaleDateTime } from "../functionalComponents/FormatDateTimeToLocale";


const calculateDaysAgo = (date) => {
  if (!date) return "Invalid Date";

  const today = new Date(); // Get current local time
  const localDate = new Date(convertToLocaleDateTime(date)); // Convert UTC to local time

  const differenceInMilliseconds = today - localDate;
  const differenceInDays = Math.floor(
    differenceInMilliseconds / (1000 * 60 * 60 * 24)
  );

  if (differenceInDays === 0) {
    const differenceInHours = Math.floor(
      differenceInMilliseconds / (1000 * 60 * 60)
    );
    if (differenceInHours === 0) {
      const differenceInMinutes = Math.floor(
        differenceInMilliseconds / (1000 * 60)
      );
      if (differenceInMinutes <= 1) {
        return "Now"; // Event occurred just now or less than 1 minute ago
      }
      return `${differenceInMinutes} minutes ago`;
    }
    return `${differenceInHours} hour${differenceInHours > 1 ? "s" : ""} ago`;
  }

  return `${differenceInDays} day${differenceInDays > 1 ? "s" : ""} ago`;
};


const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiSwitch-switchBase.Mui-checked": {
      color: "#1890ff",
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#1890ff",
    },
  },
  dialogContent: {
    textAlign: "center",
    padding: "24px 36px 24px 36px",
  },
  avatar: {
    color: "green",
    margin: "0 auto",
    fontSize: "54px",
  },
  dialogActions: {
    justifyContent: "center",
    marginTop: theme.spacing(2),
  },
  header: {
    backgroundColor: "#F9F9FC",
  },
  titleGrid: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "1rem",
    backgroundColor: "#F5F9FF",
  },
  head: {
    textAlign: "center",
  },
  closeBtn: {
    display: "flex",
    alignItems: "center",
    position: "absolute",
    top: "12px",
    right: "10px",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
      color: "#FF0000",
    },
  },
  addButton: {
    border: "1px solid black",
    borderRadius: "25px",
    color: "black",
    paddingLeft: "1rem",
    paddingRight: "1rem",
    fontSize: "14px",
    textTransform: "none",
    backgroundColor: "white",
    "&:hover": {
      backgroundColor: "Black",
      color: "white",
    },
  },
  deleteButton: {
    color: theme.palette.error.main,
  },
  content: {
    marginTop: theme.spacing(2),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    //color: '#fff',
    backgroundColor: "rgba(0, 0, 0, 0.1)",
  },
  inline: {
    fontSize: "1.35rem",
    display: "inline",
    fontWeight: 550,
    marginBottom: "0.5rem",
  },
  heading: {
    fontSize: "1.5rem",
    display: "inline",
    fontWeight: 600,
    marginBottom: "0.5rem",
  },
  hrLine: {
    backgroundColor: "grey",
    width: "2.5rem",
    height: "3px",
    margin: "inherit",
    marginBottom: "1.5rem",
    marginTop: "0.25rem",
  },
  hr: {
    border: "1px solid grey",
    marginTop: "0.5rem",
    marginBottom: "0.5rem",
    width: "100%",
    borderBottom: "thick",
  },
  textfieldWidth: {
    width: "85%",
    marginTop: "8px",
  },
  hideDropdown: {
    "& .MuiAutocomplete-popupIndicator": {
      display: "none",
    },
    "& .MuiAutocomplete-clearIndicator": {
      display: "none",
    },
  },
  hideDeleteIcon: {
    "& .MuiChip-deleteIcon": {
      display: "none",
    },
    color: "#000000",
    border: "1px solid #000000",
    marginRight: "4px",
  },
  required: {
    color: "red",
    marginLeft: "4px",
  },
  requiredStar: {
    color: "red",
  },
  title: {
    fontSize: "1.5rem",
    fontWeight: 600,
    marginBottom: theme.spacing(2),
  },
  subtitle: {
    fontWeight: 600,
  },
  input: {
    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "&[type=number]": {
      "-moz-appearance": "textfield",
    },
    overflow: "hidden",
    pointerEvents: "none",
    touchAction: "none",
    userSelect: "none",
    resize: "none",
  },
  "@keyframes slideIn": {
    from: {
      transform: "translateX(100%)",
    },
    to: {
      transform: "translateX(0)",
    },
  },
}));

const EditRolesAndAccess = ({
  openDialog,
  closeEditScreen,
  selectedRole,
  handleRefresh,
  departmentDetails,
  featuresAccess,
  openSuccessDialog,
  setOpenSuccessDialog
}) => {
  const classes = useStyles();
  const didMountRef = useRef(false);
  const dispatch = useDispatch();
  const [view, setView] = useState("RoleDetails"); // Current tab view
  const [showDrawer, setShowDrawer] = useState(false);
  const [roleName, setRoleName] = useState(selectedRole?.role_name);
  const [initialDepartmentName, setInitialDepartmentName] = useState(
    selectedRole.departmentName
  );
  const [handledUpdateOnce, setHandledUpdateOnce] = useState(false);
  // const hasHandledUpdateRef = useRef(false);
  const [initialRoleName, setInitialRoleName] = useState(
    selectedRole.role_name
  ); // Initial role name
  const [roleDescription, setRoleDescription] = useState(
    selectedRole.role_description
  );
  const [originalDescription, setOriginalDescription] = useState(
    selectedRole.role_description
  ); // Backup of original
  const [editingDescription, setEditingDescription] = useState(false);
  const [editingRoleName, setEditingRoleName] = useState(false);
  const [deleteRole, setDeleteRole] = useState(false);
  const [updateError, setUpdateError] = useState(false);
  const [updatedData, setUpdatedData] = useState({});
  const [openDrawer, setOpenDrawer] = useState(false);
  // const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [userDepartmentRole, setUserDepartmentRole] = useState({});
  const [autofillChecked, setAutofillChecked] = useState(false);

  const [optionsAndPermissions, setOptionsAndPermissions] = useState({
    stepAuthenticated: true,
    editPhoneNumber: true,
    azureAdSignIn: true,
  });

  const DeleteCollaboratorRoleData = useSelector((state) => {
    return state?.pcmp?.common?.rolesAndAccess?.deleteCollaboratorRole
      ? state?.pcmp?.common?.rolesAndAccess?.deleteCollaboratorRole
      : [];
  });

  const updateCollaboratorRoleData = useSelector(
    (state) => state?.pcmp?.common?.rolesAndAccess?.updateCollaboratorRole || {}
  );

  const fetchDepartmentsList = useSelector((state) =>
    state?.user?.fetchUserfromDeptDetails
      ? state?.user?.fetchUserfromDeptDetails
      : "data"
  );

  // const departmentDetails = useSelector((state) =>
  //   state?.user?.fetchDepartments?.data
  //     ? state?.user?.fetchDepartments.data
  //     : []
  // );
  // useEffect(() => {
  //   dispatch(fetchDepartmentDetails());
  // }, []);

  const prevUpdateCollaboratorRoleData = usePrevious(
    updateCollaboratorRoleData
  );

  const teamMembersList = useSelector((state) => {
    return state?.pcmp?.common?.teamMembers?.teamMembersDetails;
  });

  const teamMembersListLoading = useSelector((state) => {
    return state?.pcmp?.common?.teamMembers?.teamMembersDetailsLoading || {};
  });

  useEffect(() => {
    dispatch({
      type: FETCH_TEAM_ASSOCIATES_LOADING,
      payload: true,
    });
    dispatch(
      fetchTeamAssociates({
        departmentID: selectedRole.departmentID,
        collaborator_role_id: selectedRole.collaborator_role_id,
        searchString: "all",
        status: "Active",
      })
    );
  }, []);

  const errRef = useRef();
  const scrollToTop = () => {
    setTimeout(
      () => errRef.current.scrollIntoView({ behavior: "smooth", block: "end" }),
      100
    );
  };

  useEffect(() => {
    dispatch({
      type: FETCH_USERFROM_DEPT_LOADING,
      payload: true,
    });
    dispatch(fetchUserfromDepartment());
  }, []);

  // const handleClose = () => {
  //   dispatch({
  //     type: UPDATE_COLLABORATOR_ROLE_CHANGES,
  //     value: {},
  //   });
  //   handleRefresh();
  //    setOpenSuccessDialog(false);
  //   closeEditScreen();
  //  };

  const handleTabChange = (event, newValue) => {
    setView(newValue);
  };
  const UserAvatar = ({ createdByImage, createdByName }) => {
    return (
      <Box display="flex" alignItems="center">
        <Avatar
          src={createdByImage} // Use the Base64 string here
          alt={createdByName} // Optional: Alt text for accessibility
          style={{ marginRight: "8px" }} // Adjust spacing if needed
        />
      </Box>
    );
  };

  const handleConfirmDelete = () => {
    dispatch({
      type: DELETE_COLLABORATOR_ROLE,
      value: {},
    });
    setDeleteRole(false);
    closeEditScreen();
    handleRefresh();
  };

  const handleProceedDelete = () => {
    // setShowDrawer(false);
    setUserDepartmentRole({})
    setAutofillChecked(false)
    setOpenDrawer(true);
  };
  const handleDeleteRole = () => {
    // setShowDrawer(true); // Close the dialog after deletion

    if (selectedRole?.userCount === 0) {
      dispatch(
        deleteCollaboratorRole({
          collaborator_role_id: selectedRole?.collaborator_role_id,
          saasUserChangesList: [],
        })
      );

      dispatch({
        type: DELETE_COLLABORATOR_ROLE,
        payload: {},
      });

      setDeleteRole(true);
    } else {
      setShowDrawer(true);
    }
  };

  const handleConfirmChanges = () => {
    setDeleteRole(true);
    setOpenDrawer(false);
    setShowDrawer(false);
    dispatch({
      type: DELETE_COLLABORATOR_ROLE,
      payload: {},
    });

    if (selectedRole) {
      const saasUserChangesList = Object.entries(userDepartmentRole)
        .map(([userID, roleInfo]) => {
          if (!roleInfo) return null;

          const { selectedDepartmentID, selectedRoleId, markedDepartment, selectedRole } =
            roleInfo;

          if (!selectedRoleId || !markedDepartment) return null; // Skip if no role is selected

          // Find the matching role object
          const selectedRoleObj = markedDepartment.rolesList.find(
            (role) => role.collaborator_role_id === selectedRoleId
          );

          if (!selectedRoleObj) return null; // Skip if no role object is found

          return {
            saas_user_id: Number(userID), // Ensure correct ID format
            department_id: selectedDepartmentID,
            collaborator_role_id: selectedRoleObj.collaborator_role_id,
            role_name: selectedRole,
          };
        })
        .filter(Boolean); // Remove null values

      dispatch(
        deleteCollaboratorRole({
          collaborator_role_id: selectedRole?.collaborator_role_id,
          saasUserChangesList: saasUserChangesList,
        })
      );
    }
  };

  const handleDepartmentChange = (userID, departmentID) => {
    setUserDepartmentRole((prevState) => {
      const selectedDept = fetchDepartmentsList?.departmentDetailsList.find(
        (dept) => dept.departmentID === departmentID
      );

      if (!selectedDept) return;

      return {
        ...prevState,
        [userID]: {
          ...prevState[userID],
          selectedDepartmentID: departmentID,
          // markedDepartment: selectedDept,
          markedDepartment: {
            ...selectedDept, // ✅ Ensures correct department data is set
            rolesList: selectedDept.rolesList || [], // Avoids undefined rolesList
          },
          selectedRole: null, // Reset role when department changes
          selectedRoleId: null,
        },
      };
    });
  };

  const getFirstUserId = () => {
    const firstUser = teamMembersList?.data?.find(
      (user) =>
        userDepartmentRole[user.saas_user_id]?.selectedDepartmentID &&
        userDepartmentRole[user.saas_user_id]?.selectedRole
    );
    return firstUser?.saas_user_id;
  };

  const handleAutofillChange = (event) => {
    const isChecked = event.target.checked;
    setAutofillChecked(isChecked);

    if (isChecked) {
      const firstUserId = getFirstUserId();
      if (!firstUserId) return;

      const firstUserDept =
        userDepartmentRole[firstUserId]?.selectedDepartmentID;
      const firstUserRole = userDepartmentRole[firstUserId]?.selectedRole;
      const firstUserMarkedDept =
        userDepartmentRole[firstUserId]?.markedDepartment;

      if (!firstUserDept || !firstUserRole || !firstUserMarkedDept) {
        // alert("Please select department and role for the first user first.");
        setAutofillChecked(false);
        return;
      }

      setUserDepartmentRole((prevState) => {
        const updatedState = { ...prevState };

        // Ensure data is available
        if (teamMembersList?.data?.length > 0) {
          teamMembersList.data.forEach((user) => {
            if (user.saas_user_id !== firstUserId) {
              updatedState[user.saas_user_id] = {
                ...prevState[user.saas_user_id], // Preserve existing data
                selectedDepartmentID: firstUserDept,
                selectedRole: firstUserRole,
                markedDepartment: firstUserMarkedDept,
              };
            }
          });
        }

        return updatedState; // Return the updated state
      });
    }
  };

  const handleRoleChange = (userID, roleName) => {
    setUserDepartmentRole((prevState) => {
      const updatedDepartment = prevState[userID]?.markedDepartment; // Ensure latest department data
      const selectedRole = updatedDepartment?.rolesList?.find(
        (role) => role.role_name === roleName
      );

      return {
        ...prevState,
        [userID]: {
          ...prevState[userID],
          selectedRole: roleName,
          selectedRoleId: selectedRole?.collaborator_role_id || null,
          saas_user_id: userID,
        },
      };
    });
  };

  const handleChangeOptionsAndPermissions = (event) => {
    setOptionsAndPermissions({
      ...optionsAndPermissions,
      [event.target.name]: event.target.checked,
    });
  };

  const handleRenameChanges = () => {
    setUpdateError(false);
    // setOpenSuccessDialog(false);
    dispatch({
      type: UPDATE_COLLABORATOR_ROLE_CHANGES,
      payload: {},
    });
    setEditingRoleName(false);
    const requestObject = {
      collaboratorRoleData: {
        collaboratorRoleDetails: {
          collaborator_role_id: selectedRole?.collaborator_role_id,
          role_name: roleName,
          role_description: null,
        },
        screensAndFeatures: null,
      },
    };

    dispatch(updateCollaboratorRoleChanges(requestObject));
  };

  useEffect(() => {
    if (didMountRef.current) {
      if (
        JSON.stringify(updateCollaboratorRoleData) !==
        JSON.stringify(prevUpdateCollaboratorRoleData)
      ) {
          if (updateCollaboratorRoleData?.status === true) {
          // setLoading(false);
          setUpdateError(false);
          setUpdatedData(updateCollaboratorRoleData);
          setOpenSuccessDialog(true);
        } else if (updateCollaboratorRoleData.status === false) {
          // setLoading(false);
          setUpdateError(true);
          scrollToTop();
          setUpdatedData(updateCollaboratorRoleData);
          setOpenSuccessDialog(false);
        }
      }
    } else {
      didMountRef.current = true;
    }
  }, [updateCollaboratorRoleData, prevUpdateCollaboratorRoleData]);

  const handleDiscardChanges = () => {
    setRoleDescription(originalDescription);
    setEditingDescription(false);
  };

  const handleSaveChanges = () => {
    setUpdateError(false);
     dispatch({
      type: UPDATE_COLLABORATOR_ROLE_CHANGES,
      payload: {},
    });
    setEditingDescription(false);
    const requestObject = {
      collaboratorRoleData: {
        collaboratorRoleDetails: {
          collaborator_role_id: selectedRole?.collaborator_role_id,
          role_name: null,
          role_description: roleDescription,
        },
        screensAndFeatures: null,
      },
    };

    dispatch(updateCollaboratorRoleChanges(requestObject));
  };

  const isSaveDisabled = roleDescription === originalDescription;

  const renderRoleDetails = () => (
    <Grid container spacing={3} style={{ marginTop: 16 }}>
      {/* Description */}
      <Grid
        style={{
          border: "2px solid #E0E0E0",
          borderRadius: "0.5rem",
          padding: "2rem",
          marginBottom: "1rem",
        }}
        item
        xs={12}
      >
        <Typography variant="subtitle1" style={{ fontWeight: "600" }}>
          Description
        </Typography>
        <Typography
          variant="body2"
          style={{ color: "#808080", marginBottom: "1rem" }}
        >
          Should be clear for anyone using this role, so that they can allow
          correct people to join as team members in the platform.
        </Typography>
        {editingDescription ? (
          <>
            <TextField
              fullWidth
              multiline
              value={roleDescription}
              // onChange={(e) => setRoleDescription(e.target.value)}
              onChange={(e) => {
                const regex = /^[a-zA-Z(),\-\/. ]*$/;
                // Allows alphabets, commas, hyphens, slashes, and spaces
                if (regex.test(e.target.value)) {
                  setRoleDescription(e.target.value);
                }
              }}
              variant="outlined"
              onBlur={(e) => {
                const { value } = e.target;
                // Trim leading and trailing spaces for string values
                if (typeof value === "string" && value.trim() !== value) {
                  setRoleDescription(value.trim());
                }
              }}
            />
            <Grid
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexDirection: "row",
              }}
            >
              <Grid
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  gap: "0.3rem",
                }}
              >
                <Typography variant="body2" color="black">
                  Last updated by
                </Typography>
                <UserAvatar
                  createdByImage={selectedRole.lastUpdatedByImage}
                  createdByName={selectedRole.lastUpdatedByName}
                />
                <Typography style={{ fontWeight: "600" }}>
                  {selectedRole.lastUpdatedByName}
                </Typography>
                <Typography style={{ color: "#808080" }}>
                  {calculateDaysAgo(selectedRole.last_updated_date)}
                </Typography>

                <Grid item></Grid>
              </Grid>
              <Grid style={{ marginTop: "0.3rem" }}>
                <Button
                  onClick={handleDiscardChanges}
                  style={{ marginRight: "8px", backgroundColor: "#D3D3D3", textTransform: 'none' }}
                >
                  Discard Changes
                </Button>
                <Button
                  variant="contained"
                  onClick={handleSaveChanges}
                  disabled={isSaveDisabled}
                  style={{ cursor: "pointer", backgroundColor: "#286ACF", color: "#fff", textTransform: 'none' }}
                >
                  Save Changes
                </Button>
              </Grid>
            </Grid>
          </>
        ) : (
          <div>
            <Typography variant="body2">{roleDescription}</Typography>
            <Grid
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexDirection: "row",
              }}
            >
              <Grid
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  gap: "0.3rem",
                }}
              >
                <Typography variant="body2" color="black">
                  Last updated by
                </Typography>
                <UserAvatar
                  createdByImage={selectedRole.lastUpdatedByImage}
                  createdByName={selectedRole.lastUpdatedByName}
                />
                <Typography style={{ fontWeight: "600" }}>
                  {selectedRole.lastUpdatedByName}
                </Typography>
                <Typography style={{ color: "#808080" }}>
                  {calculateDaysAgo(selectedRole.last_updated_date)}
                </Typography>

                <Grid item>
                  {/* <RandomAvatar name={hardcodedData.createdBy} /> */}
                </Grid>
              </Grid>
              {(localStorage?.roleName === "Admin" &&
               (localStorage?.departmentId === "null" ||
               Number(localStorage?.getItem("departmentId")) === 1 ))
                // || Number(localStorage?.departmentId) === selectedRole?.departmentID
                && (
                  <Grid>
                    <Typography
                      style={{
                        color: "#3F51B5",
                        cursor: "pointer",
                        textDecoration: "underline",
                      }}
                      onClick={() => setEditingDescription(true)}
                    >
                      Edit description
                    </Typography>
                  </Grid>
                )}
            </Grid>
          </div>
        )}
      </Grid>

      {/* Options and Permissions */}
      <Grid item xs={12}>
        <Grid
          style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
          container
          spacing={2}
        >
          <Grid
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexDirection: "row",
              border: "2px solid #E0E0E0",
              borderRadius: "0.5rem",
              padding: "1rem",
            }}
          >
            <Grid item xs={10}>
              <Typography style={{ fontweight: "600" }} variant="subtitle1">
                2-Step Authenticated
              </Typography>
              <Typography style={{ color: "#808080" }} variant="body2">
                Authenticate the person using a code sent to their device.
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Switch
                classes={{ root: classes.root }}
                disabled={optionsAndPermissions.stepAuthenticated}
                checked={optionsAndPermissions.stepAuthenticated}
                onChange={handleChangeOptionsAndPermissions}
                name="stepAuthenticated"
              />
            </Grid>
          </Grid>
          <Grid
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexDirection: "row",
              border: "2px solid #E0E0E0",
              borderRadius: "0.5rem",
              padding: "1rem",
            }}
          >
            <Grid item xs={10}>
              <Typography style={{ fontweight: "600" }} variant="subtitle1">
                Edit Phone Number
              </Typography>
              <Typography style={{ color: "#808080" }} variant="body2">
                Don’t allow the user to edit their phone number.
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Switch
                classes={{ root: classes.root }}
                disabled={optionsAndPermissions.editPhoneNumber}
                checked={optionsAndPermissions.editPhoneNumber}
                onChange={handleChangeOptionsAndPermissions}
                name="editPhoneNumber"
              />
            </Grid>
          </Grid>

          {localStorage.getItem('collabType') !== 'CMO' && <Grid
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexDirection: "row",
              border: "2px solid #E0E0E0",
              borderRadius: "0.5rem",
              padding: "1rem",
            }}
          >
            <Grid item xs={10}>
              <Typography style={{ fontweight: "600" }} variant="subtitle1">
                Ping Sign-In Enabled
              </Typography>
              <Typography style={{ color: "#808080" }} variant="body2">
                Enable this option to use Ping credentials.
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Switch
                classes={{ root: classes.root }}
                disabled={optionsAndPermissions.azureAdSignIn}
                checked={optionsAndPermissions.azureAdSignIn}
                onChange={handleChangeOptionsAndPermissions}
                name="azureAdSignIn"
              />
            </Grid>
          </Grid>}
        </Grid>
      </Grid>
    </Grid>
  );

  // Permissions Tab
  // const renderPermissions = () => (
  //   <Typography style={{ marginTop: 16 }}>Permissions content here...</Typography>
  // );

  // Team Members Tab

  return (
    <>
      <BackDropLoading />
      <Dialog open={openDialog} fullScreen>

        <Grid
          style={{
            paddingLeft: "2rem",
            paddingRight: "2rem",
            paddingTop: "2rem",
            paddingBottom: "2rem",
          }}
          container
          direction="column"
        >
          {/* Header Section */}
          <Typography variant="h5" style={{
            fontWeight: "bold"
          }} >
            Edit Role
          </Typography>
          <Grid
            container
            // alignItems="center"
            // justifyContent="space-between"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Button
              startIcon={<ArrowBackIosIcon />}
              onClick={closeEditScreen}
              style={{ textTransform: "none", fontWeight: "550" }}
            >
              Back
            </Button>
            {(localStorage?.roleName === "Admin" &&
               (localStorage?.departmentId === "null" ||
              Number(localStorage?.getItem("departmentId")) === 1 ))
              //  || Number(localStorage?.departmentId) ===
              // selectedRole?.departmentID
               &&
              featuresAccess?.deleteRole && (
                <Button
                  variant="contained"
                  onClick={handleDeleteRole}
                  style={{
                    border: "1px solid red",
                    backgroundColor: "white",
                    color: "red",
                    padding: "0.2rem",
                    paddingTop: "0.5rem",
                    paddingBottom: "0.5rem",
                    fontWeight: "550",
                    marginTop: "2rem",
                    marginRight: "1rem",
                  }}
                >
                  <DeleteOutlinedIcon style={{ color: "red" }} />
                  <Typography variant="h6" style={{ fontWeight: 550, textTransform: 'none' }}>
                    Delete Role
                  </Typography>
                </Button>
              )}
          </Grid>

          {updateError === true && (
            <Grid
              ref={(el) => {
                errRef.current = el;
              }}
              style={{
                // paddingLeft: "150px",
                paddingTop: "8px",
                width: "93%",
                paddingBottom: "16px",
              }}
            >
              {/* {Object.keys(updatedData.errorDescription).map((key) => ( */}
              <Typography
                variant="h6"
                style={{
                  border: "1px solid #FF0000",
                  backgroundColor: "#FFF0F0",
                  opacity: "1",
                  textAlign: "center",
                  padding: "0.8rem",
                  marginLeft: "4rem",
                  fontSize: "0.875rem",
                }}
              >
                {updatedData?.errorDescription
                  ? updatedData.errorDescription
                  : updatedData.errorMessage}
              </Typography>
              {/* ))}  */}
            </Grid>
          )}

          <Grid container alignItems="center">
            <Typography
              variant="h5"
              style={{ fontWeight: "600" }}
              display="inline"
            >
              {selectedRole?.departmentName
                ? selectedRole?.departmentName
                : "NA"}
            </Typography>
            <Typography style={{ fontWeight: "bold", padding: "0 4px" }} display="inline">
              -
            </Typography>

            {editingRoleName ? (
              <>
                <TextField
                  value={roleName}
                  // onChange={(e) => setRoleName(e.target.value)}
                  onChange={(e) => {
                    const regex = /^[a-zA-Z(),\-\/ ]*$/; // Allows alphabets, commas, hyphens, slashes, and spaces
                    if (regex.test(e.target.value)) {
                      setRoleName(e.target.value);
                    }
                  }}
                  onBlur={(e) => {
                    const { value } = e.target;
                    // Trim leading and trailing spaces for string values
                    if (typeof value === "string" && value.trim() !== value) {
                      setRoleName(value.trim());
                    }
                  }}
                  placeholder="Enter role name"
                  variant="outlined"
                  size="small"
                  style={{ marginRight: 8 }}
                />
                {(localStorage?.roleName === "Admin" &&
                  (localStorage?.departmentId === "null" ||
               Number(localStorage?.getItem("departmentId")) === 1 )) 
              //  || Number(localStorage?.departmentId) ===
              //     selectedRole?.departmentID
                   && (
                    <Button
                      // onClick={() => setEditingRoleName(false)}
                      onClick={handleRenameChanges}
                      variant="contained"
                      color="secondary"
                      size="small"
                      style={{ textTransform: "none", marginRight: 8 }}
                      disabled={roleName === initialRoleName}
                    >
                      Rename
                    </Button>
                  )}
                <Button
                  onClick={() => {
                    setRoleName(initialRoleName); // Reset roleName to initial value
                    setEditingRoleName(false);
                  }}
                  size="small"
                  style={{
                    textTransform: "none",
                    color: "red",
                  }}
                >
                  X
                </Button>
              </>
            ) : (
              <>
                <Typography
                  variant="h5"
                  display="inline"
                  style={{
                    cursor: "pointer",
                    fontWeight: "600",
                    textDecoration:
                      roleName !== initialRoleName ? "underline" : "none", // Apply underline if roleName has changed
                  }}
                  onClick={() => setEditingRoleName(true)}
                >
                  {roleName}
                </Typography>
                {(localStorage?.roleName === "Admin" &&
                 (localStorage?.departmentId === "null" ||
                Number(localStorage?.getItem("departmentId")) === 1 )) 
                // || Number(localStorage?.departmentId) ===
                //   selectedRole?.departmentID
                   && (
                    <Button
                      onClick={() => setEditingRoleName(true)}
                      style={{
                        marginLeft: 8,
                        textTransform: "none",
                        textDecoration: "underline",
                        color: "#3f51b5", // Blue color
                      }}
                      size="small"
                    >
                      Rename
                    </Button>
                  )}
              </>
            )}
          </Grid>

          <Grid
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
              gap: "0.3rem",
            }}
          >
            <Typography variant="body2" color="black">
              Created by
            </Typography>
            <UserAvatar
              createdByImage={selectedRole.createdByImage}
              createdByName={selectedRole.createdByName}
            />
            <Typography style={{ fontWeight: "600" }}>
              {selectedRole.createdByName}
            </Typography>
            <Typography style={{ color: "#808080" }}>
              {calculateDaysAgo(selectedRole.creation_date)}
            </Typography>

            <Grid item>
              {/* <RandomAvatar name={hardcodedData.createdBy} /> */}
            </Grid>
          </Grid>
        </Grid>

        <DialogContent
          style={{
            paddingLeft: "2rem",
            paddingRight: "2rem",
            paddingTop: "2rem",
            paddingBottom: "2rem",
          }}
        >
          <Tabs
            value={view}
            onChange={handleTabChange}
            indicatorColor="secondary"
            textColor="secondary"
            style={{ color: "black" }}
          // style={{ borderBottom: "1px solid #ddd" }}
          >
            <Tab
              style={{
                color: view === "RoleDetails" ? "#1890ff" : "black",
              }}
              label="Role Details"
              value="RoleDetails"
            />
            <Tab
              style={{
                color: view === "Permissions" ? "#1890ff" : "black",
              }}
              label="Permissions"
              value="Permissions"
            />

            <Tab
              style={{ color: view === "TeamMembers" ? "#1890ff" : "black" }}
              //label="Team Members"
              label={`Team Members (${selectedRole?.userCount || 0})`}
              value="TeamMembers"
            />
          </Tabs>
          <Grid item xs={12}>
            {view === "RoleDetails" && renderRoleDetails()}
            {view === "Permissions" && (
              <Permissions
                selectedRole={selectedRole}
                closeEditScreen={closeEditScreen}
                handleRefresh={handleRefresh}
              />
            )}
            {view === "TeamMembers" && (
              <EditTeamMembers
                teamMembersListLoading={teamMembersListLoading}
                teamMembersList={teamMembersList}
                fetchDepartmentsList={fetchDepartmentsList}
                departmentDetails={departmentDetails}
                featuresAccess={featuresAccess}
                selectedRole={selectedRole}
              />
            )}
          </Grid>
        </DialogContent>

        <Backdrop className={classes.backdrop} open={showDrawer}>
          <Slide direction="left" in={showDrawer} mountOnEnter unmountOnExit>
            <Box
              width={410}
              sx={{
                // width: "20rem",
                height: "100%",
                position: "fixed",
                right: 0,
                top: 0,
                backgroundColor: "#fff",
                padding: "16px",
                boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                zIndex: 1300,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Box>
                <Typography variant="h6" fontWeight="bold" mb={2}>
                  Delete department
                </Typography>
                <hr className={classes.hr} />
                <Typography variant="body1" gutterBottom>
                  <b>Warning:</b>
                </Typography>
                <Typography
                  variant="body2"
                  style={{
                    border: "2px solid red", // Red border
                    borderRadius: "4px",
                    padding: "8px",
                    fontWeight: "bold",
                    color: "red", // Red text
                    lineHeight: 1.5,
                  }}
                >
                  Role deletion: You are deleting the role. Team members may
                  lose access to certain areas of the application. You can't
                  reverse this process. To proceed, please assign alternate
                  department-role(s) for all the affected team members.
                </Typography>
              </Box>

              <Box
                display="flex"
                justifyContent="space-between"
                style={{ paddingBottom: "3rem" }}
                mt={4}
              >
                <Button
                  variant="outlined"
                  onClick={() => setShowDrawer(false)}
                  style={{
                    textTransform: "none",
                    borderRadius: "8px",
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  //onClick={() => handleProceedDelete(department.departmentID,department.tempID)}
                  // onClick={() => handleProceedDelete(selectedDepartment.departmentID,selectedDepartment.tempID)}
                  onClick={handleProceedDelete}
                  style={{
                    textTransform: "none",
                    borderRadius: "8px",
                    backgroundColor: "#1976D2",
                  }}
                >
                  Proceed
                </Button>
              </Box>
            </Box>
          </Slide>
        </Backdrop>

        {DeleteCollaboratorRoleData.status === true && (
          <Dialog open={deleteRole} maxWidth="sm" fullWidth>
            <DialogContent className={classes.dialogContent}>
              <CheckCircleIcon className={classes.avatar} />

              <Typography variant="h6" style={{ marginTop: "10px" }}>
                Deleted role successfully
              </Typography>
              <Typography variant="body1" style={{ marginTop: "10px" }}>
                The role has been deleted successfully.
              </Typography>

              <DialogActions className={classes.dialogActions}>
                <Button
                  variant="contained"
                  color="primary"
                  endIcon={<ChevronRight />}
                  style={{
                    borderRadius: "20px",
                    textTransform: "none",
                  }}
                  onClick={handleConfirmDelete}
                >
                  Ok
                </Button>
              </DialogActions>
            </DialogContent>
          </Dialog>
        )}
      </Dialog>


      <Drawer
        anchor="right"
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
      >
        <Box
          width={410}
          p={3}
          display="flex"
          flexDirection="column"
          height="100%"
        >
          <Typography variant="h6" style={{ fontWeight: 550 }}>
            Delete role
          </Typography>
          <hr
            width={410}
            style={{
              backgroundColor: "grey",
              // width: "1rem",
              height: "1px",
              margin: "inherit",
              marginBottom: "1rem",
              marginTop: "1rem",
            }}
          />
          {/* <hr className={classes.hrLine} /> */}
          <Typography
            variant="h6"
            style={{ fontWeight: 600, marginBottom: "0.5rem" }}
          >
            Assign Alternate department-role(s)
          </Typography>

          {teamMembersList?.data
            ?.filter((member) => member.account_status === "Active")
            ?.map((user, index) => {
              const isDepartmentSelected =
                !!userDepartmentRole[user.saas_user_id]?.selectedDepartmentID;
              const isRoleSelected =
                !!userDepartmentRole[user.saas_user_id]?.selectedRole;

              return (
                <Box
                  key={user.saas_user_id}
                  style={{
                    backgroundColor:
                      (isDepartmentSelected && isRoleSelected) ||
                        autofillChecked
                        ? "#f3faee"
                        : "#ffe6e6",
                    marginBottom: "0.5rem",
                    marginRight: "1rem",
                    paddingLeft: "1rem",
                    paddingTop: "1rem",
                    paddingBottom: "1rem",
                    paddingRight: "1rem",
                    borderRadius: "0.2rem",
                  }}
                  width="90%"
                >
                  <Grid
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "flex-start",
                    }}
                  >
                    <Grid>
                      <UserAvatar profileImage={user?.profile_pic} />
                    </Grid>
                    <Grid
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                    >
                      <Typography
                        style={{ fontWeight: "bold", fontSize: "0.8rem" }}
                      >
                        {user.full_name}
                      </Typography>
                      <Typography
                        style={{ fontSize: "0.8rem" }}
                        variant="body2"
                        color="textSecondary"
                      >
                        {user.email_address}
                      </Typography>
                    </Grid>
                  </Grid>

                  {/* Department Dropdown */}

                  {/* <FormControl fullWidth style={{ marginTop: 10 }}>
                    <Typography
                      variant="body1"
                      style={{ marginBottom: 5, fontWeight: 550 }}
                    >
                      Select Department{" "}
                      <span style={{ color: "red", fontWeight: "bold" }}>
                        {" "}
                        *
                      </span>
                    </Typography>
                    <TextField
                      size="small"
                      select
                      variant="outlined"
                      fullWidth
                      
                      value={
                        autofillChecked &&
                        user.saas_user_id !== getFirstUserId()
                          ? userDepartmentRole[getFirstUserId()]
                              ?.selectedDepartmentID
                          : userDepartmentRole[user.saas_user_id]
                              ?.selectedDepartmentID || ""
                      }
                      onChange={(e) =>
                        handleDepartmentChange(
                          user.saas_user_id,
                          e.target.value
                        )
                      }
                      disabled={
                        autofillChecked &&
                        user.saas_user_id !== getFirstUserId()
                      }
                    >
                      {fetchDepartmentsList?.departmentDetailsList?.map(
                        (department) => (
                          <MenuItem
                            key={department.departmentID}
                            value={department.departmentID}
                          >
                            {department.departmentName}
                          </MenuItem>
                        )
                      )}
                    </TextField>
                  </FormControl>

                      <FormControl fullWidth style={{ marginTop: 10 }}>
                    <Typography variant="body1" style={{ marginBottom: 5 }}>
                      Select Role{" "}
                      <span style={{ color: "red", fontWeight: "bold" }}>
                        {" "}
                        *
                      </span>
                    </Typography>
                    <TextField
                      select
                      variant="outlined"
                      size="small"
                      fullWidth
                                            value={
                        autofillChecked &&
                        user.saas_user_id !== getFirstUserId()
                          ? userDepartmentRole[getFirstUserId()]?.selectedRole
                          : userDepartmentRole[user.saas_user_id]
                              ?.selectedRole || ""
                      }
                      onChange={(e) =>
                        handleRoleChange(user.saas_user_id, e.target.value)
                      }
                      disabled={
                        autofillChecked &&
                        user.saas_user_id !== getFirstUserId()
                      }
                    >
                                           {(autofillChecked
                        ? userDepartmentRole[getFirstUserId()]?.markedDepartment
                            ?.rolesList
                        : userDepartmentRole[user.saas_user_id]
                            ?.markedDepartment?.rolesList
                      )
                        ?.filter(
                          (role) => role.role_name !== initialRoleName
                          // role.collaborator_role_id !== selectedRole.collaborator_role_id
                        )
                        ?.map((role) => (
                          <MenuItem key={role.role_name} value={role.role_name}>
                            {role.role_name}
                          </MenuItem>
                        ))}
                    </TextField>
                  </FormControl> */}

                  <FormControl fullWidth style={{ marginTop: 10 }}>
                    <Typography
                      variant="body1"
                      style={{ marginBottom: 5, fontWeight: 550 }}
                    >
                      Select Department{" "}
                      <span style={{ color: "red", fontWeight: "bold" }}>
                        *
                      </span>
                    </Typography>
                    <TextField
                      size="small"
                      select
                      variant="outlined"
                      fullWidth
                      value={
                        autofillChecked &&
                          user.saas_user_id !== getFirstUserId()
                          ? userDepartmentRole[getFirstUserId()]
                            ?.selectedDepartmentID
                          : userDepartmentRole[user.saas_user_id]
                            ?.selectedDepartmentID || ""
                      }
                      onChange={(e) =>
                        handleDepartmentChange(
                          user.saas_user_id,
                          e.target.value
                        )
                      }
                      // disabled={
                      //   autofillChecked &&
                      //   user.saas_user_id !== getFirstUserId()
                      // }
                      disabled={autofillChecked}
                    >
                      {fetchDepartmentsList?.departmentDetailsList
                        ?.filter((department) =>
                          Number(localStorage?.departmentId) ===
                            selectedRole?.departmentID
                            ? department.departmentID ===
                            selectedRole?.departmentID
                            : true
                        )
                        .map((department) => (
                          <MenuItem
                            key={department.departmentID}
                            value={department.departmentID}
                          >
                            {department.departmentName}
                          </MenuItem>
                        ))}
                    </TextField>
                  </FormControl>

                  <FormControl fullWidth style={{ marginTop: 10 }}>
                    <Typography variant="body1" style={{ marginBottom: 5 }}>
                      Select Role{" "}
                      <span style={{ color: "red", fontWeight: "bold" }}>
                        *
                      </span>
                    </Typography>
                    <TextField
                      select
                      variant="outlined"
                      size="small"
                      fullWidth
                      value={
                        autofillChecked &&
                          user.saas_user_id !== getFirstUserId()
                          ? userDepartmentRole[getFirstUserId()]?.selectedRole
                          : userDepartmentRole[user.saas_user_id]
                            ?.selectedRole || ""
                      }
                      onChange={(e) =>
                        handleRoleChange(user.saas_user_id, e.target.value)
                      }
                      // disabled={
                      //   autofillChecked &&
                      //   user.saas_user_id !== getFirstUserId()
                      // }
                      disabled={autofillChecked}
                    >
                      {fetchDepartmentsList?.departmentDetailsList
                        ?.find(
                          (dept) =>
                            dept.departmentID ===
                            (autofillChecked
                              ? userDepartmentRole[getFirstUserId()]
                                ?.selectedDepartmentID
                              : userDepartmentRole[user.saas_user_id]
                                ?.selectedDepartmentID)
                        )
                        ?.rolesList?.filter(
                          (role) => role.role_name !== selectedRole?.role_name
                        )
                        ?.map((role) => (
                          <MenuItem key={role.role_name} value={role.role_name}>
                            {role.role_name}
                          </MenuItem>
                        ))}
                    </TextField>
                  </FormControl>

                  {index === 0 && (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={autofillChecked}
                          disabled={!isDepartmentSelected || !isRoleSelected}
                          onChange={handleAutofillChange}
                        />
                      }
                      label="Assign same alternate department-role to remaining team members"
                    // onClick={applyAutofill}
                    />
                  )}
                </Box>
              );
            })}

          <Box
            display="flex"
            justifyContent="space-between"
            mt="auto"
            style={{ marginBottom: "1rem" }}
          >
            <Button
              variant="contained"
              color="secondary"
              onClick={() => setOpenDrawer(false)}
              style={{
                backgroundColor: "rgba(209, 210, 214, 0.94)",
                color: "black",
              }}
            >
              Back
            </Button>


            <Button
              variant="contained"
              color="secondary"
              onClick={handleConfirmChanges}
              style={{
                backgroundColor: !teamMembersList?.data
                  ?.filter((member) => member.account_status === "Active")
                  ?.every(
                    (user) =>
                      !!userDepartmentRole[user.saas_user_id]?.selectedDepartmentID &&
                      !!userDepartmentRole[user.saas_user_id]?.selectedRole
                  ) ? "#b0c7eb" : "#286acf",
                color: "#fff",
                cursor: !teamMembersList?.data
                  ?.filter((member) => member.account_status === "Active")
                  ?.every(
                    (user) =>
                      !!userDepartmentRole[user.saas_user_id]?.selectedDepartmentID &&
                      !!userDepartmentRole[user.saas_user_id]?.selectedRole
                  ) ? "not-allowed" : "pointer",
              }}
              // disabled={
              //   !teamMembersList?.data?.every(
              //     (user) =>
              //       !!userDepartmentRole[user.saas_user_id]
              //         ?.selectedDepartmentID &&
              //       !!userDepartmentRole[user.saas_user_id]?.selectedRole
              //   )
              // }
              disabled={
                !teamMembersList?.data
                  ?.filter((member) => member.account_status === "Active")
                  ?.every(
                    (user) =>
                      !!userDepartmentRole[user.saas_user_id]?.selectedDepartmentID &&
                      !!userDepartmentRole[user.saas_user_id]?.selectedRole
                  )
              }
            >
              confirm Changes
            </Button>
          </Box>
        </Box>
      </Drawer>
    </>
  );
};

export default EditRolesAndAccess;
